/**
 * Backend Response
 */
export var STATUS = ['ACCURITY', 'SOURCE', 'NO_UPDATES', 'UPDATE_AVAILABLE'];
export var NOT_NULL = ['YES', 'NO', 'N/A'];
export var DATA_STRUCTURE_TYPE = ['TABLE', 'VIEW', 'COLLECTION', 'SHEET'];
//# sourceMappingURL=types.js.map